<div #postContentInner *ngIf="item" class="post-content" id="postContent{{item.urlHash}}">
  <div class="date">{{item.date | date:'dd MMM yyyy'}}</div>
  <div class="btn-mobile-close" (click)="onClose()" *ngIf="displayMode === 'mobile'">
    <span class="delete">
      <svg height="18" viewBox="0 0 15 15" width="18" xmlns="http://www.w3.org/2000/svg">
        <path d="M 2.7265625,1.5898438 C 1.8742874,1.5644139 1.2561125,2.6509254 1.7851562,3.3476562 2.4980316,4.1259268 3.2737509,4.8481792 4.0120156,5.6038125 4.6440781,6.235875 5.2761406,6.8679375 5.9082031,7.5 4.5579926,8.8550194 3.197942,10.200627 1.8539022,11.561549 1.2849775,12.172637 1.7105205,13.253126 2.5117188,13.386719 3.12816,13.543694 3.5660897,13.036274 3.9489688,12.642828 5.1326459,11.459151 6.3163229,10.275474 7.5,9.0917969 c 1.355025,1.3502161 2.700638,2.7102721 4.061566,4.0543171 0.612055,0.567884 1.691203,0.143874 1.825153,-0.657833 0.156964,-0.616446 -0.35044,-1.054371 -0.743891,-1.43725 C 11.459151,9.8673538 10.275474,8.6836769 9.0917969,7.5 10.442013,6.1449745 11.80207,4.7993614 13.146114,3.4384333 13.715013,2.8273389 13.289457,1.7468907 12.488281,1.6132812 11.871835,1.4563171 11.43391,1.963721 11.051031,2.3571719 9.8673538,3.540849 8.6836769,4.724526 7.5,5.9082031 6.1449804,4.5579926 4.7993725,3.1979419 3.4384508,1.8539022 3.2411795,1.686475 2.9853438,1.5912809 2.7265625,1.5898438 Z" fill="#95a0b1" fill-rule="nonezero"></path>
      </svg>
    </span>
  </div>
  <div class="add-to-preview" *ngIf="previewMode">
    <button type="button"
            class="button add-review"
            placement="bottom-right"
            ngbTooltip="{{'info_box.post_hover.add_post' | translate}}"
            (click)="addToPreviewed(item)">+
    </button>
  </div>

  <div #postImageContainer class="post-background">
    <a [routerLink]="['/post/']" queryParamsHandling="merge" class="post-img-container"
       [queryParams]="{influencerId: item.blog_id, urlHash: item.urlHash, fullUrl: item.url, relativePath: item.relativepath, hideBackButton: true, activeAccount: activeAccount}" target="_blank">
      <img #postImage class="post-img"
           onerror="this.onerror=null;this.src='assets/images/No_Image.png'" (error)="onImageError()"
           [ngClass]="{'story-image': item.isStory}"
           src="{{item.imageUrl}}" alt="No image" />
    </a>
    <post-type-display [postType]="item.postType" [borderless]="true"></post-type-display>
  </div>

  <div class="info">
    <a *ngIf="!currentInfluencer" [routerLink]="['/post/']" queryParamsHandling="merge"
      [queryParams]="{influencerId: item.blog_id, urlHash: item.urlHash, fullUrl: item.url, relativePath: item.relativepath, influencerGroupId: influencerGroupId, activeAccount: activeAccount, hideBackButton: true}" target="_blank">
      <div class="platform-icon">
        <img [src]="getPlatformIcon(item.platformId)" alt=""/>
      </div>
      <div class="row kpi">
        <div class="col-6 col-sm-6">
          <div>{{ 'dashboard.order_bar.reach' | translate }}</div>
          <span class="number"
                placement="bottom"
                ngbTooltip="{{'info_box.post_hover.post_reach' | translate}}">
            {{reach}}
          </span>
        </div>
        <div class="col-6 col-sm-6">
          <div>{{ 'dashboard.order_bar.impact' | translate }}</div>
          <span class="number"
                placement="bottom"
                ngbTooltip="{{'info_box.post_hover.post_impact' | translate}}">
            {{impact}}
          </span>
        </div>
      </div>
    </a>
    <a *ngIf="currentInfluencer" [routerLink]="['/dashboard/post/' + item.urlHash]" target="_blank">
      <div class="platform-icon">
        <img [src]="getPlatformIcon(item.platformId)" alt=""/>
      </div>
      <div class="row kpi">
        <div class="col-6 col-sm-6">
          <div>{{ 'dashboard.order_bar.reach' | translate }}</div>
          <span class="number"
                placement="bottom"
                ngbTooltip="{{'info_box.post_hover.post_reach' | translate}}">
            {{reach}}
          </span>
        </div>
        <div class="col-6 col-sm-6">
          <div>{{ 'dashboard.order_bar.impact' | translate }}</div>
          <span class="number"
                placement="bottom"
                ngbTooltip="{{'info_box.post_hover.post_impact' | translate}}">
            {{impact}}
          </span>
        </div>
      </div>
    </a>
    <a class="title" [routerLink]="['/influencer/' + item.blog_id +'/overview']"
       [queryParams]="{group_id: influencerGroupId, from_path: 'discover/posts', target: target, activeAccount: activeAccount, hideBackButton: true}"
       target="_blank"
       queryParamsHandling="merge">
      <span class="influencer-name">{{item.influencerName}}</span>
      <p class="post-title">
        {{getTitle(item.title)}}
      </p>
    </a>
    <div class="d-flex flex-row flex-wrap justify-content-center mention-summarize"
         *ngIf="item && item.mentions && item.mentions.length > 0">
      <span *ngFor="let mention of item.mentions; let last = last " >{{mention}}<span [hidden]="last">,&nbsp;</span></span>
    </div>
    <div class="d-block d-sm-none go-to-post">
      <button  type="button" class="button green" (click)="gotoPost($event)">{{'common.btn.post_insights' | translate}}</button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/post-list/influencer-overview-post-content/influencer-overview-post-content.component.html